<template>
  <app-select v-model="value"
              :data-title="$t('message.sidebar.message.termsOfUse')"
              :data-menu-heading="$t('message.sidebar.message.termsOfUse')"
              data-menu-width="auto"
              :data-button-gradient="true"
              :data-items="list"
              :infiniteId="infiniteId"
              infinite-loading
              @load="load"
              @search="v => search(v)"
              @opened="reset" />
</template>

<script>
import AppSelect from "@components/Select";
import filter from "@mixins/filter";
import _ from "lodash";

export default {
  components: {
    AppSelect,
  },

  data() {
    return {
      key: "usageTerms",
      page: 0,
      loadedUsageTerms: [],
      filter: "",
      loadOnFilters: false,
      isComplete: false,
      infiniteId: Date.now(),
    };
  },

  props: {},

  computed: {
    list() {
      return _.map(this.loadedUsageTerms, (usageTerm) => {
        return {
          id: usageTerm.termId,
          label: usageTerm.name,
        };
      });
    },
  },

  methods: {
    async load($state) {
      if (this.isComplete) {
        $state.loaded();
        $state.complete();

        return;
      }

      const loadedUsageTerms = await this.$api.usageTerms.listToFilter({
        page: this.page,
        filter: this.filter,
      });

      this.loadedUsageTerms.push(...loadedUsageTerms);

      this.page += 1;

      if ($state) {
        if (loadedUsageTerms.length) {
          $state.loaded();
        } else {
          this.isComplete = true;
          $state.complete();
        }
      }
    },
    reload() {
      this.isComplete = false;

      this.page = 0;
      this.loadedUsageTerms = [];

      this.infiniteId++;
    },

    search(text) {
      this.filter = text;

      this.reload();
    },

    reset() {
      this.filter = "";
      this.reload();
    },
  },

  mounted() {},

  mixins: [filter],
};
</script>

<style scoped>
</style>
